/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantKeyResponse } from '../../models/tenant-key-response';

export interface GetTenantKeyByShortCode$Params {

/**
 * shortCode of the tenant (based on the subdomain)
 */
  short_code: string;
}

export function getTenantKeyByShortCode(http: HttpClient, rootUrl: string, params: GetTenantKeyByShortCode$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantKeyResponse>> {
  const rb = new RequestBuilder(rootUrl, getTenantKeyByShortCode.PATH, 'get');
  if (params) {
    rb.path('short_code', params.short_code, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantKeyResponse>;
    })
  );
}

getTenantKeyByShortCode.PATH = '/api/v1/tenants/config/{short_code}/key';
